import React, { useEffect, useState } from 'react';
import { Grid, Paper, LinearProgress, Skeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// import Chart from 'react-apexcharts';
//import { PaidSharp } from '@mui/icons-material';
import SideBar from './sideBar';
import LineChartToggle from './lineChartToggle';
import Rightbar from './rightbar';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import UpdateIcon from '@mui/icons-material/Update';
// import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
// import DonutChartTwo from './TrendsViewCharts/DonutChartTwo';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
// import Uniquejourney from './KPICards/Uniquejourney';
// import {
//   avgDwelTime,
//   avgWaitingTime
//   // footFall
// } from '../../../api/sentinelAPI';
// import {
//   footfallCard,
//   // empfootFallCard,
//   // assCusRatioCard,
//   empFootfallCount,
//   empZonewiseCount
// } from '../../../api/sentinelAPI';
import NoDataImg from '../../../assets/images/No_data-amico.svg';
import { CgSpinner } from 'react-icons/cg';
import { FaCheck } from 'react-icons/fa6';
import { RxCross2 } from 'react-icons/rx';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { SELECTED_TIME } from 'store/actions';
// const infer_localUrl = 'http://localhost:9990';
import axios from 'axios';
import GroupIcon from '@mui/icons-material/Group';
import dummydata from './data.json'; // Adjust path accordingly
import { getCustomerDwellTime, getCustomerEmployeeRatio, getEmployeeAvailability, getUniqueWalkinWalkout } from 'api';
// import { set } from 'date-fns';

const StorePage = () => {
  const theme = useTheme();
  const navigateTo = useNavigate();
  const date = useSelector((state) => state.customization.currentDate);
  const dispatch = useDispatch();
  const [authenticated, setAuthenticated] = useState(false);
  const [status, setStatus] = useState({ loading: true, verified: false });
  const [avgWaitingData, setAvgWaitingData] = useState(false);
  const [avgWaiting, setAvgWaiting] = useState(false);

  //avg dweltime data fetch start
  const [storeDwelTime, setStoreDwelTime] = useState(false);
  // const [averageDwellTime, setAverageDwellTime] = useState(false);
  const [dweltimeData, setDweltimedata] = useState(false);
  const [footfalldata, setFootfalldata] = useState(false);
  const [ftfall, setftfall] = useState([]);
  // const [empFtFall, setEmpFtFall] = useState(false);
  const [empFtFallCount, setEmpFtFallCount] = useState(false);
  const [empZoneCounts, setEmpZoneCounts] = useState(false);
  const [cusAssRatio, setCusAssRatio] = useState(false);
  const [cusAssRatioData, setCusAssRatioData] = useState(false);
  const selectedTime = useSelector((state) => state.customization.selectedTime);
  const startTime = new Date(selectedTime.start_time);
  const endTime = new Date(selectedTime.end_time);

  const formattedStartTimeIST = startTime.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }).split(',')[1];
  const formattedEndTimeIST = endTime.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }).split(',')[1];

  // const [dt, setdt] = useState('');
  // const calDate = (d) => {
  //   setdt(d.toString());
  //   return d;
  // };

  const [isMounted, setIsMounted] = useState(false);

  // async function getDataDwell(commonBody, signal) {
  //   try {
  //     const data = dummydata.avgDwelTime;

  //     if (!signal.aborted) {
  //       if (!data || data.zone_wise_dwell_time.length === 0) {
  //         setStoreDwelTime(false);
  //         setDweltimedata(false);
  //       } else if (data && data.zone_wise_dwell_time.length > 0) {
  //         const storeAvgDwellTime = data.dwel_time;
  //         setStoreDwelTime(storeAvgDwellTime);

  //         setDweltimedata(data.zone_wise_dwell_time);
  //       }
  //     }
  //   } catch (error) {
  //     if (!signal.aborted) {
  //       setStoreDwelTime(false);
  //       setDweltimedata(false);
  //       console.log(error);
  //     }
  //   }
  // }
  async function getDataDwell(commonBody, signal) {
    try {
      const requestData = {
        date: commonBody,
        source_id: 'dombivli'
      };
      const response = await getCustomerDwellTime(requestData);
      const data = response.data.data[0].avgDwelTime;

      if (!signal.aborted) {
        if (!data || data.zone_wise_dwell_time.length === 0) {
          setStoreDwelTime(false);
          setDweltimedata(false);
        } else {
          setStoreDwelTime(data.dwel_time);
          setDweltimedata(data.zone_wise_dwell_time);
        }
      }
    } catch (error) {
      if (!signal.aborted) {
        setStoreDwelTime(false);
        setDweltimedata(false);
        console.log(error);
      }
    }
  }

  // async function getFootfalldata(commonBody, signal) {
  //   try {
  //     const data = dummydata.footfall;

  //     if (!signal.aborted) {
  //       if (!data || data.zoneFootfall.length === 0) {
  //         setFootfalldata(false);
  //         setftfall(false);
  //       } else if (data && data.zoneFootfall.length > 0) {
  //         const avgFootfall = data.store_footfall;
  //         const zoneFootfall = data.zoneFootfall;
  //         setftfall(zoneFootfall);
  //         setFootfalldata(avgFootfall);
  //       }
  //     }
  //   } catch (error) {
  //     if (!signal.aborted) {
  //       setFootfalldata(false);
  //       setftfall(false);
  //       console.log(error);
  //     }
  //   }
  // }
  async function getFootfalldata(commonBody, signal) {
    try {
      const requestData = {
        date: commonBody,
        source_id: 'dombivli'
      };
      const response = await getUniqueWalkinWalkout(requestData);
      const data = response.data.data[0]?.footfall;

      if (!signal.aborted) {
        if (!data || data.zoneFootfall.length === 0) {
          setFootfalldata(false);
          setftfall(false);
        } else if (data && data.zoneFootfall.length > 0) {
          const avgFootfall = data.store_footfall;
          const zoneFootfall = data.zoneFootfall;
          const employeeftfall = data.employee_footfall;
          setEmpFtFallCount(employeeftfall);
          setftfall(zoneFootfall);
          setFootfalldata(avgFootfall);
        }
      }
    } catch (error) {
      if (!signal.aborted) {
        setFootfalldata(false);
        setftfall(false);
        console.log(error);
      }
    }
  }

  // async function getAvgWaitingTime(commonBody, signal) {
  //   try {
  //     const data = dummydata.avgWaitingTime;

  //     if (!signal.aborted) {
  //       if (!data || data.length === 0) {
  //         setAvgWaiting(false);
  //         setAvgWaitingData(false);
  //       } else if (data && data.length > 0) {
  //         const timeValues = data.map((obj) => obj.avg);
  //         const sum = timeValues.reduce((acc, val) => acc + val, 0);
  //         const avgTime = sum / timeValues.length;
  //         // const avgRatio = data.result;
  //         const zoneTime = data;
  //         setAvgWaiting(avgTime);
  //         setAvgWaitingData(zoneTime);
  //       }
  //       // console.log('Avg Waiting Time', data);
  //     }
  //   } catch (error) {
  //     if (!signal.aborted) {
  //       setAvgWaiting(false);
  //       setAvgWaitingData(false);
  //       console.log(error);
  //     }
  //   }
  // }

  async function getAvgWaitingTime(commonBody, signal) {
    try {
      const requestData = {
        date: commonBody,
        source_id: 'dombivli'
      };
      const response = await getEmployeeAvailability(requestData);
      const data = response.data.data; // Extract the relevant data

      if (!signal.aborted) {
        if (!data || !data.allZones || data.allZones.length === 0) {
          setAvgWaiting(0);
          setAvgWaitingData([]);
        } else {
          // Store-level average availability
          const avgTime = data.avgAvail || 0;

          // Zone-wise availability mapping
          const zoneData = data.allZones.map((zone) => ({
            _id: zone.zone, // Using `zone` as the zone name (_id)
            count: zone.percentAvail // Mapping percentAvail to count
          }));

          // Update state
          setAvgWaiting(avgTime);
          setAvgWaitingData(zoneData);
        }
      }
    } catch (error) {
      if (!signal.aborted) {
        setAvgWaiting(0);
        setAvgWaitingData([]);
        console.log('Error fetching employee availability:', error);
      }
    }
  }

  async function getEmpFootfallCount(commonBody, signal) {
    try {
      const data = dummydata.employeeEntranceCount;

      if (!signal.aborted) {
        if (!data || data.length === 0) {
          setEmpFtFallCount(false);
        } else if (data && data.length > 0) {
          // const avgFootfallValues = data.map((obj) => obj.avg_footfall);
          // const sum = avgFootfallValues.reduce((acc, val) => acc + val, 0);
          // const avgFootfall = sum / avgFootfallValues.length;
          // const zoneFootfall = data;
          // setEmpFtFallCount(data[0].count);
          // setEmpFtFallData(zoneFootfall);
        }
      }
    } catch (error) {
      if (!signal.aborted) {
        setEmpFtFallCount(false);
        console.log(error);
      }
    }
  }

  async function getEmpZonewiseCount(commonBody, signal) {
    try {
      const data = dummydata.zoneEmployeeCount;

      if (!signal.aborted) {
        if (!data || data.length === 0) {
          setEmpZoneCounts(false);
        } else if (data && data.length > 0) {
          setEmpZoneCounts(data);
          // setEmpFtFallData(zoneFootfall);
        }
      }
    } catch (error) {
      if (!signal.aborted) {
        setEmpZoneCounts(false);
        console.log(error);
      }
    }
  }

  // async function getCustomerAssociateRatio(commonBody, signal) {
  //   try {
  //     const data = dummydata.customerAssociateRatio;

  //     if (!signal.aborted) {
  //       if (!data || data.length === 0) {
  //         setCusAssRatio(false);
  //         setCusAssRatioData(false);
  //       } else if (data && data.length > 0) {
  //         const cusCounts = data.map((obj) => obj.customer_count);
  //         const totalCus = cusCounts.reduce((acc, val) => acc + val, 0);
  //         const empCounts = data.map((obj) => obj.employee_count);
  //         const totalEmp = empCounts.reduce((acc, val) => acc + val, 0);
  //         const avgRatio = (totalCus / totalEmp).toFixed(2);
  //         // const avgRatio = data.result;
  //         const countData = data;
  //         setCusAssRatio(avgRatio);
  //         setCusAssRatioData(countData);
  //       }
  //     }
  //   } catch (error) {
  //     if (!signal.aborted) {
  //       setCusAssRatio(false);
  //       setCusAssRatioData(false);
  //       console.log(error);
  //     }
  //   }
  // }

  async function getCustomerAssociateRatio(commonBody, signal) {
    try {
      const requestData = {
        date: commonBody,
        source_id: 'dombivli'
      };
      const response = await getCustomerEmployeeRatio(requestData);

      if (!signal.aborted) {
        const data = response?.data?.data || [];
        console.log(data);

        if (data.length === 0) {
          setCusAssRatio(false);
          setCusAssRatioData(false);
        } else {
          setCusAssRatioData(data);

          const ratios = data.map((obj) => parseFloat(obj.employee_to_customer_ratio.split(':')[1]) || 0);
          const avgRatio = ratios.length > 0 ? (ratios.reduce((acc, val) => acc + val, 0) / ratios.length).toFixed(2) : 'N/A';
          setCusAssRatio(avgRatio);
        }
      }
    } catch (error) {
      if (!signal.aborted) {
        setCusAssRatio(false);
        setCusAssRatioData(false);
        console.error('Error fetching customer-employee ratio:', error);
      }
    }
  }

  useEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false);
    };
  }, []);

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    if (isMounted) {
      // const commonBody = {
      //   start_time: formattedStartTimeIST,
      //   end_time: formattedEndTimeIST,
      //   start_date: date,
      //   storeId: '65c5e26a0b5be5dc7af327dc'
      // };

      const commonBody = {
        start_date: date
      };

      const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
      };

      const formattedDate = formatDate(date);

      getFootfalldata(formattedDate, signal);
      getDataDwell(formattedDate, signal);
      getEmpFootfallCount(commonBody, signal);
      getEmpZonewiseCount(commonBody, signal);
      getAvgWaitingTime(formattedDate, signal);
      getCustomerAssociateRatio(formattedDate, signal);
    }

    return () => {
      abortController.abort();
    };
  }, [date, isMounted, formattedStartTimeIST, formattedEndTimeIST]);

  //avg dweltime data fetch end

  //end
  const mainContentStyle = {
    // flexGrow: '1',
    maxWidth: '100%',
    minWidth: '0',
    height: '100%',
    // width:'auto',
    // marginLeft: isSmallScreen ? '0' : '200px',
    // marginRight: isSmallScreen ? '0' : '200px',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
      width: '100%'
    }
  };

  const paperStyle = {
    width: '100%',
    maxHeight: '280px',
    height: '280px',
    padding: '10px',
    marginBottom: '20px',
    position: 'relative',
    left: 'auto',
    borderRadius: '15px',
    display: 'flex',
    alignItems: 'center',
    flex: '1'
  };

  ftfall && ftfall.sort((a, b) => a.footfall - b.footfall);
  dweltimeData && dweltimeData.sort((a, b) => a.averageDuration - b.averageDuration);
  // empFtFallData && empFtFallData.sort((a, b) => a.avg_footfall - b.avg_footfall);
  empZoneCounts && empZoneCounts.sort((a, b) => a.count - b.count);
  avgWaitingData && avgWaitingData.sort((a, b) => b.avg - a.avg);
  // assCusRatioData && assCusRatioData.sort((a, b) => a.intercations_per_minute - b.intercations_per_minute);

  const AuthorizationAPI = async () => {
    const accessToken = localStorage.getItem('accessToken');
    try {
      let data = [];
      try {
        console.log('start session api 1st call');
        data = await axios.post(
          // `${infer_localUrl}/start_session?self&token=${accessToken}`,
          `https://db.neophyte.live/sentinel-api/api/sentinel/start_session`,
          {}, // Pass an empty object for the request body
          {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          }
        );
      } catch {
        console.log('start session api 2nd call');
        // data = await axios.post(
        //   `http://10.115.67.9:9990/start_session?self&token=${accessToken}`,
        //   {}, // Pass an empty object for the request body
        //   {
        //     headers: {
        //       Authorization: `Bearer ${accessToken}`
        //     }
        //   }
        // );
      }
      if (data) {
        console.log('Authorization data', data);
      }
      if (data.data.message === 'Session created successfully') {
        console.log('Session Started');
        setStatus({ loading: false, verified: true });
        const timeoutId = setTimeout(() => {
          setAuthenticated(true);
        }, 1500);
        return () => {
          clearTimeout(timeoutId);
        };
      } else {
        console.log('Session could not be started');
        setStatus({ loading: false, verified: false });
        if (localStorage.getItem('accessToken')) {
          localStorage.removeItem('accessToken');
        }
        const timeoutId = setTimeout(() => {
          navigateTo('/');
        }, 1500);
        return () => {
          clearTimeout(timeoutId);
        };
      }
    } catch (error) {
      console.log('Error starting session:', error);
      setStatus({ loading: false, verified: false });
      if (localStorage.getItem('accessToken')) {
        localStorage.removeItem('accessToken');
      }
      const timeoutId = setTimeout(() => {
        navigateTo('/');
      }, 1500);
      return () => {
        clearTimeout(timeoutId);
      };
    }
  };

  useEffect(() => {
    dispatch({
      type: SELECTED_TIME,
      selectedTime: {
        start_time: new Date().setHours(10, 0, 0, 0),
        end_time: new Date().setHours(22, 0, 0, 0)
      }
    });
    const timeoutId = setTimeout(() => {
      AuthorizationAPI();
    }, 1500);
    return () => {
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {!authenticated ? (
        <div className="w-screen h-screen flex justify-center place-items-center bg-gray-100">
          <div className="px-5 py-4 flex justify-center place-items-center bg-white rounded-md shadow-lg">
            <span>
              {status.loading ? (
                'Authenticating, please wait...'
              ) : (
                <>{status.verified ? 'Authenticated successfully, redirecting...' : 'Authentication failed, please try again...'}</>
              )}
            </span>
            {status.loading ? (
              <CgSpinner className="ml-4 text-xl text-gray-500 animate-spin" />
            ) : (
              <>
                {status.verified ? (
                  <FaCheck className="ml-4 text-xl text-emerald-500" />
                ) : (
                  <RxCross2 className="ml-4 text-xl text-rose-500" />
                )}
              </>
            )}
          </div>
        </div>
      ) : (
        <Grid container spacing={1}>
          <SideBar selField="storeOverview" />
          {/* <Grid item md={1.5}></Grid> */}
          <Grid item md={12} sx={mainContentStyle}>
            <Grid container spacing={1}>
              <Grid
                item
                xs={12}
                md={3}
                sm={6}
                sx={{
                  width: '100%',
                  // height:'100px',
                  mb: -1,
                  mt: 1,
                  [theme.breakpoints.up('sm')]: {
                    mb: -1,
                    mt: 1 // Height for screens equal to or larger than 'md' breakpoint
                  },
                  [theme.breakpoints.up('md')]: {
                    mb: -1,
                    mt: -1 // Height for screens equal to or larger than 'md' breakpoint
                  }
                }}
              >
                <Paper elevation={3} sx={paperStyle}>
                  {ftfall && ftfall.length > 0 ? (
                    <div className="flex w-full flex-col gap-1">
                      <div className="flex items-center justify-center gap-2 w-full">
                        {ftfall ? (
                          <DirectionsWalkIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
                        ) : (
                          <Skeleton variant="circular" width={60} height={45} />
                        )}
                        <div className="w-full">
                          {ftfall ? (
                            <div className="flex items-center gap-2">
                              <div className="flex items-center gap-1">
                                <p className="text-3xl">{footfalldata ? Math.round(footfalldata) : 0}</p>
                                <p className="text-sm text-gray-600 mt-1">Customers</p>
                              </div>
                              <div className="h-8 w-[1px] bg-gray-300"></div>
                              <div className="flex items-center gap-1">
                                <p className="text-3xl">{empFtFallCount || 0}</p>
                                <p className="text-sm text-gray-600 mt-1">Employees</p>
                              </div>
                            </div>
                          ) : (
                            <Skeleton variant="rectangular" className="mb-3 rounded-sm" width={200} height={50} />
                          )}

                          {ftfall ? (
                            <p className="text-lg mt-1">Footfall Trend</p>
                          ) : (
                            <Skeleton variant="rectangular" width={150} height={15} className="mb-2 rounded-sm" />
                          )}
                        </div>
                      </div>
                      {ftfall ? (
                        <div className="bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
                          {(() => {
                            const maxFootfall = Math.max(...ftfall.map((item) => item.footfall)); // Get max footfall
                            return ftfall.map((item, index) => {
                              const percentage = (item.footfall / maxFootfall) * 100; // Normalize
                              const barcolor = percentage >= 80 ? '#44BE54' : percentage >= 50 ? '#ffbf00' : '#ff413a';

                              return (
                                <div className="mt-2" key={index}>
                                  <div className="flex gap-1 items-center">
                                    <div className="rounded-full h-4 w-4" style={{ backgroundColor: '#2D9BBC' }}></div>
                                    <div>
                                      {item.zone_name} : {item.footfall}
                                    </div>
                                  </div>
                                  <LinearProgress
                                    variant="determinate"
                                    value={percentage}
                                    sx={{
                                      marginTop: '5px',
                                      backgroundColor: '#c8c8c8',
                                      '& .MuiLinearProgress-bar': {
                                        backgroundColor: `${barcolor}`
                                      }
                                    }}
                                  />
                                </div>
                              );
                            });
                          })()}
                        </div>
                      ) : (
                        <Skeleton variant="rectangular" height={184} className="rounded-md" />
                      )}
                    </div>
                  ) : (
                    <img style={{ height: '392px' }} src={NoDataImg} alt="No data" />
                  )}
                </Paper>
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
                sm={6}
                sx={{
                  width: '100%',
                  mb: -1,
                  mt: 1,
                  [theme.breakpoints.up('sm')]: {
                    mb: -1,
                    mt: 1 // Height for screens equal to or larger than 'md' breakpoint
                  },
                  [theme.breakpoints.up('md')]: {
                    mb: -1,
                    mt: -1 // Height for screens equal to or larger than 'md' breakpoint
                  }
                }}
              >
                <Paper elevation={3} sx={paperStyle}>
                  {dweltimeData && dweltimeData.length > 0 ? (
                    <div className="flex flex-col w-full gap-1">
                      <div className="flex items-center justify-center gap-2 w-full">
                        {storeDwelTime ? (
                          <UpdateIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
                        ) : (
                          <Skeleton variant="circular" width={45} height={45} />
                        )}
                        <div className="w-full">
                          {storeDwelTime ? (
                            <p className="text-3xl">
                              {storeDwelTime >= 3600
                                ? `${Math.round(storeDwelTime / 3600)} hr`
                                : storeDwelTime >= 60
                                ? `${Math.round(storeDwelTime / 60)} min`
                                : `${Math.round(storeDwelTime)} sec`}
                            </p>
                          ) : (
                            <Skeleton variant="rectangular" className="mb-3 rounded-sm" width={50} height={15} />
                          )}
                          {storeDwelTime ? (
                            <p className="text-lg">Avg Dwell Time</p>
                          ) : (
                            <Skeleton variant="rectangular" width={150} height={15} className=" mb-5 rounded-sm" />
                          )}
                        </div>
                      </div>
                      {storeDwelTime ? (
                        <div className=" bg-slate-100 flex-grow overflow-y-auto h-[184px] scrollbar rounded-lg p-2.5">
                          {dweltimeData.map((item, index) => {
                            const percentage = (item.averageDuration / storeDwelTime) * 100;
                            const barcolor = percentage >= 80 ? '#44BE54' : percentage >= 50 ? '#ffbf00' : '#ff413a';
                            return (
                              <div className="mt-2" key={index}>
                                <div className="flex gap-1 items-center">
                                  <div
                                    className=" rounded-full h-4 w-4"
                                    style={{
                                      // backgroundColor: `${item.zoneColourHex}`
                                      backgroundColor: '#2D9BBC'
                                    }}
                                  >
                                    {' '}
                                  </div>
                                  <div>
                                    {item.zone_name} :{' '}
                                    {item.averageDuration >= 3600
                                      ? `${Math.round(item.averageDuration / 3600)} hr`
                                      : item.averageDuration >= 60
                                      ? `${Math.round(item.averageDuration / 60)} min`
                                      : `${Math.round(item.averageDuration)} sec`}
                                  </div>
                                </div>
                                <LinearProgress
                                  variant="determinate"
                                  value={Math.min(100, percentage)}
                                  sx={{
                                    marginTop: '5px',
                                    backgroundColor: '#c8c8c8',
                                    '& .MuiLinearProgress-bar': {
                                      backgroundColor: `${barcolor}` // Set color for filled part
                                    }
                                  }}
                                />
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <Skeleton variant="rectangular" height={184} className="rounded-md" />
                      )}
                    </div>
                  ) : (
                    <img style={{ height: '392px' }} src={NoDataImg} alt="No data" />
                  )}
                </Paper>
              </Grid>
              {/* <Grid
                item
                md={2.4}
                sm={6}
                sx={{
                  width: '100%',
                  mb: -1,
                  mt: 1,
                  [theme.breakpoints.up('sm')]: {
                    mb: -1,
                    mt: 1 // Height for screens equal to or larger than 'md' breakpoint
                  },
                  [theme.breakpoints.up('md')]: {
                    mb: -1,
                    mt: -1 // Height for screens equal to or larger than 'md' breakpoint
                  }
                }}
              >
                <Paper elevation={3} sx={paperStyle}>
                  {avgWaitingData && avgWaitingData.length > 0 ? (
                    <div className="flex flex-col w-full gap-1">
                      <div className="flex items-center justify-center gap-2 w-full">
                        {avgWaiting ? (
                          <HourglassEmptyIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
                        ) : (
                          <Skeleton variant="circular" width={45} height={45} />
                        )}
                        <div className="w-full">
                          {avgWaiting ? (
                            <p className="text-3xl">
                              {avgWaiting >= 60
                                ? `${(avgWaiting / 60).toFixed(2)} hr`
                                : avgWaiting >= 1
                                  ? `${avgWaiting.toFixed(2)} min`
                                  : `${(avgWaiting * 60).toFixed(0)} sec`}
                            </p>
                          ) : (
                            <Skeleton variant="rectangular" className="mb-3 rounded-sm" width={50} height={15} />
                          )}
                          {avgWaiting ? (
                            <p className="text-lg">Avg Waiting Time</p>
                          ) : (
                            <Skeleton variant="rectangular" width={150} height={15} className=" mb-5 rounded-sm" />
                          )}
                        </div>
                      </div>
                      {avgWaiting ? (
                        <div className=" bg-slate-100 flex-grow overflow-y-auto h-[184px] scrollbar rounded-lg p-2.5">
                          {avgWaitingData.map((item, index) => {
                            const percentage = (item.avg / avgWaiting) * 100;
                            const barcolor = percentage >= 80 ? '[#ffbf00]f413a' : percentage >= 50 ? '[#ffbf00]' : '#44BE54';
                            return (
                              <div className="mt-2" key={index}>
                                <div className="flex gap-1 items-center">
                                  <div
                                    className=" rounded-full h-4 w-4"
                                    style={{
                                      // backgroundColor: `${item.zoneColourHex}`
                                      backgroundColor: '#2D9BBC'
                                    }}
                                  >
                                    {' '}
                                  </div>
                                  <div>
                                    {item._id} :{' '}
                                    {item.avg >= 60
                                      ? `${(item.avg / 60).toFixed(2)} hr`
                                      : item.avg >= 1
                                        ? `${item.avg.toFixed(2)} min`
                                        : `${(item.avg * 60).toFixed(0)} sec`}
                                  </div>
                                </div>
                                <LinearProgress
                                  variant="determinate"
                                  value={Math.min(100, percentage)}
                                  sx={{
                                    marginTop: '5px',
                                    backgroundColor: 'rgb(241 245 249)', // Set color for unfilled part
                                    '& .MuiLinearProgress-bar': {
                                      backgroundColor: `${barcolor}` // Set color for filled part
                                    }
                                  }}
                                />
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <Skeleton variant="rectangular" height={184} className="rounded-md" />
                      )}
                    </div>
                  ) : (
                    <img style={{ height: '392px' }} src={NoDataImg} alt="No data" />
                  )}
                </Paper>
              </Grid> */}
              <Grid
                item
                md={3}
                sm={6}
                sx={{
                  width: '100%',
                  mb: -1,
                  mt: 1,
                  [theme.breakpoints.up('sm')]: {
                    mb: -1,
                    mt: 1 // Height for screens equal to or larger than 'md' breakpoint
                  },
                  [theme.breakpoints.up('md')]: {
                    mb: -1,
                    mt: -1 // Height for screens equal to or larger than 'md' breakpoint
                  }
                }}
              >
                <Paper elevation={3} sx={paperStyle}>
                  {avgWaitingData && avgWaitingData.length > 0 ? (
                    <div className="flex w-full flex-col gap-1">
                      <div className="flex items-center justify-center gap-2 w-full">
                        {avgWaiting ? (
                          <EmojiPeopleIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
                        ) : (
                          <Skeleton variant="circular" width={60} height={45} />
                        )}
                        <div className="w-full">
                          {avgWaiting ? (
                            <p className="text-3xl">{avgWaiting.toFixed(2)}%</p>
                          ) : (
                            <Skeleton variant="rectangular" className="mb-3 rounded-sm" width={50} height={20} />
                          )}

                          {avgWaiting ? (
                            <p>
                              <span className="text-lg">Avg Employee Availability</span>
                            </p>
                          ) : (
                            <Skeleton variant="rectangular" width={150} height={15} className="mb-2 rounded-sm" />
                          )}
                        </div>
                      </div>

                      {avgWaitingData ? (
                        <div className="bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
                          {(() => {
                            // Sort avgWaitingData in ascending order
                            const sortedData = [...avgWaitingData].sort((a, b) => a.count - b.count);

                            // Get max count for normalization
                            const highestFootfall = Math.max(...sortedData.map((zone) => zone.count), 1); // Avoid division by zero

                            return sortedData.map((item, index) => {
                              const percentage = ((item.count / highestFootfall) * 100).toFixed(1);
                              const barcolor = percentage >= 80 ? '#44BE54' : percentage >= 50 ? '#ffbf00' : '#ff413a';

                              return (
                                <div className="mt-2" key={index}>
                                  <div className="flex gap-1 items-center">
                                    <div className="rounded-full h-4 w-4 bg-[#2D9BBC]"> </div>
                                    <div>
                                      {item._id} : {item.count}%
                                    </div>
                                  </div>
                                  <LinearProgress
                                    variant="determinate"
                                    value={parseFloat(percentage)}
                                    sx={{
                                      marginTop: '5px',
                                      backgroundColor: '#c8c8c8',
                                      '& .MuiLinearProgress-bar': {
                                        backgroundColor: `${barcolor}` // Set color for filled part
                                      }
                                    }}
                                  />
                                </div>
                              );
                            });
                          })()}
                        </div>
                      ) : (
                        <Skeleton variant="rectangular" height={184} className="rounded-md" />
                      )}
                    </div>
                  ) : (
                    <img style={{ height: '392px' }} src={NoDataImg} alt="No data" />
                  )}
                </Paper>
              </Grid>
              <Grid
                item
                md={3}
                sm={6}
                sx={{
                  width: '100%',
                  mb: -1,
                  mt: 1,
                  [theme.breakpoints.up('sm')]: {
                    mb: -1,
                    mt: 1 // Height for screens equal to or larger than 'md' breakpoint
                  },
                  [theme.breakpoints.up('md')]: {
                    mb: -1,
                    mt: -1 // Height for screens equal to or larger than 'md' breakpoint
                  }
                }}
              >
                <Paper elevation={3} sx={paperStyle}>
                  {cusAssRatioData && cusAssRatioData.length > 0 ? (
                    <div className="flex w-full flex-col gap-1">
                      <div className="flex items-center justify-center gap-2 w-full">
                        <GroupIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
                        <div className="w-full">
                          <p className="text-3xl">1 : {cusAssRatio}</p>
                          <p>
                            <span className="text-[1.090rem]">Employee : Customer</span>
                          </p>
                        </div>
                      </div>
                      <div className="bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
                        {(() => {
                          // Sort the data in DESCENDING order based on the customer ratio value
                          const sortedData = [...cusAssRatioData].sort((a, b) => {
                            const ratioA = parseFloat(a.employee_to_customer_ratio.split(':')[1]) || 0;
                            const ratioB = parseFloat(b.employee_to_customer_ratio.split(':')[1]) || 0;
                            return ratioB - ratioA; // Descending order
                          });

                          // Get the highest ratio for normalization
                          const highestFootfall = Math.max(
                            ...sortedData.map((obj) => parseFloat(obj.employee_to_customer_ratio.split(':')[1]) || 0),
                            1
                          ); // Avoid division by zero

                          return sortedData.map((item, index) => {
                            const ratioValue = parseFloat(item.employee_to_customer_ratio.split(':')[1]) || 0;
                            const percentage = ((ratioValue / highestFootfall) * 100).toFixed(1);
                            const barcolor = percentage >= 80 ? '#ff413a' : percentage >= 50 ? '#ffbf00' : '#44BE54';

                            return (
                              <div className="mt-2" key={index}>
                                <div className="flex gap-1 items-center">
                                  <div className="rounded-full h-4 w-4" style={{ backgroundColor: '#2D9BBC' }}></div>
                                  <div>
                                    {item.zone} - {item.employee_to_customer_ratio}
                                  </div>
                                </div>
                                <LinearProgress
                                  variant="determinate"
                                  value={parseFloat(percentage)}
                                  sx={{
                                    marginTop: '5px',
                                    backgroundColor: '#c8c8c8',
                                    '& .MuiLinearProgress-bar': {
                                      backgroundColor: `${barcolor}`
                                    }
                                  }}
                                />
                              </div>
                            );
                          });
                        })()}
                      </div>
                    </div>
                  ) : (
                    <img style={{ height: '392px' }} src={NoDataImg} alt="No data" />
                  )}
                </Paper>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item md={9} sm={12}>
                <LineChartToggle />
              </Grid>
              <Grid item md={3} sm={12}>
                <Rightbar />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default StorePage;
